import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import STREET_TYPE_OPTIONS from '../definitions/StreetTypes';
import STREET_DIRECTION_OPTIONS from '../definitions/StreetDirections';
import AddressPropType from '../definitions/AddressPropType';


/**
 * 
 * @param {{
 *  unitNumber: string,
 *  streetNumber: string,
 *  streetName: string,
 *  streetType: string,
 *  streetDirection: string,
 * }} address 
 * @param fallback if the address is incomplete or missing.
 * @returns FormattedMessage
 */
function FormattedStreetAddress({ address, fallback, shouldIncludeCity, shouldIncludePostalCode }) {
    if (!address || !address.streetNumber || !address.streetName) {
        return fallback;
    }

    const {
        unitNumber,
        streetNumber,
        streetName,
        streetType,
        streetDirection,
        city,
        province,
        postalCode,
    } = address;

    return (
        <FormattedMessage
            id="base-ui.FormattedStreetAddress"
            defaultMessage={`{
                unitNumberPresent, select,
                    true {{unitNumber}-}
                    other {}
                }{streetNumber} {streetName}{
                    streetTypePresent, select,
                        true { {streetType}}
                        other {}
                }{
                    directionPresent, select,
                        true { {direction}}
                        other {}
                }{
                    cityPresent, select,
                        true {, {city} {province}}
                        other {}
                }{
                    postalCodePresent, select,
                        true { {postalCode}}
                        other {}

            }`}
            values={{
                unitNumberPresent: !!unitNumber,
                unitNumber: unitNumber,
                
                streetNumber: streetNumber,
                streetName: streetName,

                streetTypePresent: !!streetType,
                streetType: streetType
                    ? STREET_TYPE_OPTIONS.find(o => o.value === streetType).label
                    : '',

                directionPresent: !!streetDirection,
                direction: streetDirection
                    ? STREET_DIRECTION_OPTIONS.find(o => o.value === streetDirection).label
                    : '',

                cityPresent: shouldIncludeCity && !!city && !!province,
                city: city,
                province: province,

                postalCodePresent: shouldIncludePostalCode && !!postalCode,
                postalCode: postalCode,
            }}
        />
    );
}

FormattedStreetAddress.propTypes = {
    address: AddressPropType,
    fallback: PropTypes.node,
    shouldIncludeCity: PropTypes.bool,
    shouldIncludePostalCode: PropTypes.bool,
};

FormattedStreetAddress.defaultProps = {
    address: undefined,
    fallback: '',
    shouldIncludeCity: false,
    shouldIncludePostalCode: false,
};

export default FormattedStreetAddress;